import { Component, EventEmitter, forwardRef, Input, Output, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core'
import { NG_VALUE_ACCESSOR } from '@angular/forms'
import { addMonths, startOfMonth } from 'date-fns'

interface Daterange {
  startDate: Date
  endDate: Date
}

export const DATERANGE_PICKER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CalendarComponent),
  multi: true,
}

@Component({
  selector: 'calendar',
  styleUrls: ['./calendar.component.less'],
  templateUrl: './calendar.component.html',
  providers: [
    DATERANGE_PICKER_VALUE_ACCESSOR
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CalendarComponent implements OnChanges {
  @Input() startDate: Date
  @Input() endDate: Date
  @Input() min: Date
  @Input() max: Date
  @Input() firstDayOfWeek: string;
  @Output() datesChange = new EventEmitter<any>()
  dateState: Date = new Date()
  leftCalendar: Date
  rightCalendar: Date
  active: Date

  setDate(dates: {start: Date, end: Date, active: Date}) {
    this.startDate = dates.start
    this.endDate = dates.end
    this.active = dates.active
    if (!this.active) {
      const value = { startDate: dates.start, endDate: dates.end }
      this.datesChange.emit(value)
    }
  }

  showDate(dates: {start: Date, end: Date}) {
    this.startDate = dates.start
    this.endDate = dates.end
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['startDate'] || changes['endDate']) {
      this.startDate = changes['startDate'] && changes['startDate'].currentValue || this.startDate
      this.endDate = changes['endDate'] && changes['endDate'].currentValue || this.endDate
      this.updateMonths(this.startDate, this.endDate)
    }
  }

  updateMonths(startDate: Date, endDate: Date) {
    const rightDate = startOfMonth(endDate || new Date())
    const leftDate = startOfMonth(startDate || addMonths(rightDate, -1))
    const leftVisible = +leftDate === +this.leftCalendar || +leftDate === +this.rightCalendar
    const rightVisible = +rightDate === +this.leftCalendar || +rightDate === +this.rightCalendar
    if (!leftVisible || !rightVisible) {
      this.leftCalendar = leftDate
      this.rightCalendar = rightDate
    }
  }
}
